import React from 'react'
import DashboardCharts from './child/DashboardCharts';

const DashBoardLayerOne = () => {

    return (
        <>
            {/* Dashboard Charts — gráficas conectadas al endpoint */}
            <DashboardCharts />
        </>
    )
}

export default DashBoardLayerOne